const SubText = ({children}) => {
    return (
        <span className="text-[0.9em] italic">
            {children}
        </span>
    )
}

export default SubText